import { useField } from "formik";

import RadioNodeType from "../../types/RadioNodeType";
import MuiRadio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

export const Radio =
    ({ name, value, label, inline, sx, labelSx, ...props }: RadioNodeType & any) => {
  const [field] = useField(name);

  return (
      <FormControlLabel
          sx={{
              ...(inline ? { display: "inline-flex", mr: 2 } : {}),
              ...sx,
          }}
          control={
            <MuiRadio
                checked={field.value === value}
                {...props}
                onChange={() => {
                  field.onChange({
                    target: {
                      name,
                      value,
                    },
                  });
                }}
            />
          }
          label={label}
          slotProps={{
              typography: {
                  sx: labelSx,
              },
          }}
      />
  );
};

export default Radio;
